<template>
  <div>
    <AlertError
      v-if="error !== null"
      :message="error.msg"
      :error="error.e"
      @on_close="error = null"
      />
  <REDLogo class="w-40 p-4 fill-red-primary"/>
  <div class="sm:w-[512px] mt-4 mx-auto my-auto rounded-lg 
              flex flex-col shadow-2xl bg-white">
    <LoginElement
      :redirectUrl="redirectUrl"
      :bgImgPath="bgImgPath"
      :useRedTheme="useRedTheme"
      :authClient="authClient"
      @error="on_error">
      <template #h1> <slot name="h1"></slot> </template>
      <template #h2> <slot name="h2"></slot> </template>
      <template #h3> <slot name="h3"></slot> </template>
      <slot></slot>
    </LoginElement>
  </div>
</div>
</template>
<script setup>
import { useError } from "../composables/error.js";
const { on_error, error } = useError();

defineProps({
  redirectUrl: { type: String, required: true, },
  useRedTheme: { type: Boolean, default: false, },
  bgImgPath: { type: String, default: null },
  authClient: { type: Object, required: true, },
});

import LoginElement from "./LoginElement.vue";
import AlertError from "./AlertError.vue";
import REDLogo from "./REDLogo.vue";
</script>
